export default __webpack_public_path__ + "static/media/18577-vandy.bf0f474c.pdf";